import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

const Heading = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");
  return (
    <h2
      style={{
        fontWeight: 700,
        fontSize: isMobile ? "18px" : isTablet ? "20px" : "24px",
        marginBottom: isMobile ? "10px" : isTablet ? "6px" : "14px",
        color: "#1D1D1B",
        lineHeight: 1,
        letterSpacing: "-0.72px",
      }}
    >
      {children}
    </h2>
  );
};

export default Heading;
